import {DateTime} from 'luxon';

import {itemTypeSupported} from './items.js';

// Check if an order is for folders (orderObj)
export const orderIsFolder = orderObj => orderObj.name.indexOf('folder/') === 0;

// Get the Folder id from format: 'folder/ID/FOLDERNAME' || 'folder/ID'
export const getFolderIdFromOrderName = orderName => orderName.split('/')[1];
export const getFolderNameFromOrder = orderName => orderName.split('/').pop();

export const keyByDateAndType = item =>
  `${item.properties.item_type}:${DateTime.fromISO(item.properties.acquired, {
    zone: 'utc',
  })
    .startOf('day')
    .toMillis()}`;

export const groupItems = (items, keyFn) => {
  const groups = {};
  for (let i = 0, ii = items.length; i < ii; i++) {
    const item = items[i];
    // ensure the item has a geometry...
    if (item.geometry) {
      const key = keyFn(item);
      if (!groups[key]) {
        groups[key] = {
          id: key,
          properties: {
            item_type: item.properties.item_type,
            acquired: item.properties.acquired,
            items: [item],
          },
        };
      } else {
        groups[key].properties.items.push(item);
      }
    }
  }

  return groups;
};

export const orderByDateAndType = (groups, desc = true) =>
  Object.keys(groups).sort((a, b) => {
    const groupA = groups[a];
    const groupB = groups[b];

    const dateDiff = DateTime.fromISO(groupA.properties.acquired, {
      zone: 'utc',
    }).diff(
      DateTime.fromISO(groupB.properties.acquired, {zone: 'utc'})
    ).milliseconds;

    let sortV = 1;
    if (dateDiff > 1) {
      // pass
    } else if (dateDiff < 0) {
      sortV = -1;
    } else {
      sortV =
        groupA.properties.items[0].properties.item_type <
        groupB.properties.items[0].properties.item_type
          ? -1
          : 1;
    }

    return desc ? -1 * sortV : sortV;
  });

// Grab unique id from folder contents items
const getUniqueId = item => item.id;

// Reduce/Merge additional items when loading more folder contents
export const reduceContents = (prevContents, newItems) => {
  const prevIds = prevContents.map(getUniqueId);
  const keepItems = newItems.filter(
    item => prevIds.indexOf(getUniqueId(item)) < 0
  );
  return [...prevContents, ...keepItems];
};

// Augment Folders Items with additional meta data for Explorer
export const augmentItems = items =>
  items.map(item => {
    const itemType = item.properties.item_type || '';
    const isSkySat = itemType.indexOf('SkySat') >= 0;

    // Used to determine if item supports numpy or indexes
    const supported = itemTypeSupported(itemType);

    return {
      ...item,
      properties: {
        bands: isSkySat ? ['r', 'g', 'b', 'nir'] : ['b', 'g', 'r', 'nir'],
        pixelDepth: isSkySat ? 65536 : 10000,
        datatype: 'uint16',
        supports: {
          ...item.properties.supports,
          numpy: supported,
          indexes: supported,
        },
        canStream: true,
        ...item.properties,
      },
      _links: {
        thumbnail: supported
          ? `https://tiles.planet.com/data/v1/item-types/${itemType}/${item.properties.item_id}/thumb`
          : '',
        ...item._links,
      },
    };
  });
